import React from 'react';

interface Props {
    final_price: boolean
}

export class AvailableOrNot extends React.Component<Props, {}> {


    componentDidMount() {
    }

    render() {

        let final_price: boolean = this.props.final_price

        return (
            <>
                <div className="card-codes-item">
                    {final_price ?
                        <span
                            className="goods-content-text__status status-green">В наличии</span> :
                        <span
                            className="goods-content-text__status status-red">Нет в наличии</span>
                    }
                </div>
            </>
        )
    }
}

